<template>
  <div class="carbon-search">
    <multiselect
      class="carbon-search"
      v-model="search"
      placeholder="Search Carbon"
      track-by="heading"
      @search-change="asyncFind"
      @select="onSelect"
      @close="onClose"
      :clearOnSelect="true"
      :internal-search="false"
      :loading="isLoading"
      :show-labels="false"
      :options="options"
    > 
      <template slot="singleLabel" slot-scope="props">
        <div></div>
      </template>

      <template slot="noOptions" slot-scope="props">
        <div>Please enter min 3 characters to start search...</div>
      </template>

      <template slot="option" slot-scope="props">
            <div class="row no-gutters">
              <div class="col-auto d-flex align-items-center">
                  <img v-if="props.option.img != ''" class="option__image" :src="props.option.img" alt="" />
                  <i v-else class="option__icon far" :class="props.option.icon"></i>
              </div>
              <div class="col d-flex align-items-center">
                  <div>
                      <p>{{ props.option.heading }}</p>
                      <p class="small">{{ props.option.subheading }}</p>
                  </div>
              </div>
          </div><!-- /.row -->
      </template>

    </multiselect>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import { http } from 'utils'

export default {
components: {
    Multiselect
  },
  data () {
    return {
      options: [],
      search: "",
      isLoading: false
    }
  },
  methods: {
    asyncFind (query) {

      if (query.length > 2) {
        this.isLoading = true
        http.get(`/search?search=${query}`).then(response => {
          this.options = response.data
          this.isLoading = false
        })
      }
    },
    onClose () {
      //Clear any current search term
      this.$nextTick(() => {
        this.search = ""
        this.options = []
      })
    },
    onSelect (option) {
      console.log('here');
      switch(option.type) {
        case 'Client':
          this.$router.push({ name: 'clients.details', params: { client_id: option.id } })
          break
        case 'Project':
          this.$router.push({ name: 'projects.show.details', params: { project_id: option.id } })
          break
        case 'Opportunity':
          this.$router.push({ name: 'opportunities.overview', params: { opportunity_id: option.id } })
          break
        case 'Contact':
          this.$router.push({ name: 'clients.contacts', params: { client_id: option.client_id } })
          break
        case 'UserStory':
          this.$router.push({ name: 'projects.stage3.scrum.detail', params: { project_id: option.project_id, stage_id: 3, user_story_doc_id: option.user_story_doc_id, sprint_id: option.sprint_id, story_id: option.id } })
          break
      }
    }
  },

  mounted () {
    
  }
}
</script>

<style>
  
</style>
